import { Navigate, useSearchParams } from "react-router";

import { useAuthenticationContext } from "../auth/use-authentication-context";

export const LoggedOutOnlyRouteGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user } = useAuthenticationContext();
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get("invitationToken");

  if (user?.id && invitationToken)
    return (
      <Navigate
        to={`/accept-invitation?token=${encodeURIComponent(invitationToken)}`}
        replace
      />
    );

  if (user?.isSuperuser) return <Navigate to="/admin/users" />;

  if (!user?.companies?.length && user?.id)
    return <Navigate to="/account/orders" />;

  if (user?.id) return <Navigate to="/account/detailed-ordering" />;

  return children;
};
